export default __webpack_public_path__ + "static/media/box.9d89ce65.png";